import React from 'react';
import Modal from 'ui/Modal';

interface NotFoundPageProps {
    errorMessage?: string;
    errorSubtext?: string;
    buttonText?: string;
    onButtonClick?: () => void;
    buttonHref?: string;
    displayStyle?: 'cover' | 'page' | 'modal';
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ errorMessage = 'Page not found', errorSubtext, buttonText = 'View Other Posts', displayStyle = 'cover', onButtonClick, buttonHref = buttonText === 'Reload Page' ? '' : '/' }) => {

  if (displayStyle === 'modal') {

    return (
        <Modal
            isOpen={true}
            onClose={() => {}}
            title={errorMessage}
            children={
                <div className="flex flex-col items-center justify-center w-[80%] mx-4 space-y-4">
                <img src={`/avatea_404_nobg.png`} alt="404 Not Found" className="min-h-[40%] h-[200px] w-auto" />
                <h1 className="text-2xl font-semibold text-eoe-text-heading dark:text-eoe-dark-text-heading">
                </h1>
                {errorSubtext && (
                  <p className="text-sm text-eoe-text-2 dark:text-eoe-dark-text-2">
                    <span>{errorSubtext}</span>
                  </p>
                )}
                <nav className="w-full">
                  <a href={buttonHref} className="w-full">
                      <span className="btn-primary text-xs font-semibold block w-full my-2 text-center">
                          {buttonText}
                      </span>
                  </a>
                </nav>
                </div>
            }
        />
    );
  }

  return (
      <div className={`${displayStyle === 'cover' || null ? 'screen-cover' : displayStyle === 'page' ? 'section-page' : 'full-screen-page'} flex flex-col items-center justify-center`}>
          <div className="flex flex-col items-center justify-center w-[80%] mx-4 space-y-4">
              <img src={`/avatea_404_nobg.png`} alt="404 Not Found" className="min-h-[40%] h-[200px] w-auto" />
              <h1 className="text-2xl font-semibold text-eoe-text-heading dark:text-eoe-dark-text-heading">
                  <span>{errorMessage}</span>
              </h1>
              {errorSubtext && (
                <p className="text-sm text-eoe-text-2 dark:text-eoe-dark-text-2">
                  <span>{errorSubtext}</span>
                </p>
              )}
              <nav className="w-full">
                <a href={buttonHref} className="w-full">
                    <span className="btn-primary text-xs font-semibold block w-full my-2 text-center">
                        {buttonText}
                    </span>
                </a>
              </nav>
          </div>
      </div>
  );
};

export default NotFoundPage;